// Single source of truth for status -> semantic color mapping.
const STATUS_COLORS = {
  pending: "warning",
  confirmed: "info",
  processing: "info",
  completed: "success",
  success: "success",
  active: "success",
  rejected: "danger",
  failed: "danger",
  inactive: "danger",
  cancelled: "danger",
  disable: "danger",
};

/**
 * StatusBadge — soft pill badge (tinted background, deep text) with a
 * consistent status -> color mapping. Styles live in
 * src/assets/scss/custom/_akh.scss (`.akh-badge`), with dark-theme variants.
 *
 * Props:
 * - status:    status string (case-insensitive); unknown values render as
 *              "secondary"
 * - label:     optional display text override (defaults to status)
 * - className: extra classes on the badge element
 */
const StatusBadge = ({ status, label, className = "" }) => {
  const key = String(status || "").trim().toLowerCase();
  const color = STATUS_COLORS[key] || "secondary";
  return (
    <span className={`akh-badge akh-badge--${color} ${className}`.trim()}>
      {label || status}
    </span>
  );
};

export default StatusBadge;
